// @ts-check
import moment from "moment";

import { CameraStatus } from "../../constants/camera-status";

export class Camera {
  constructor(
    id = "",
    name = "",
    connected = false,
    organization = "",
    size = 0,
    type = "",
    userId = "",
    modelId = "",
    datasetId = "",
    lastConsumingExecutionId = "",
    config = {},
    fps = 0,
    resolution = "",
    createdAt = null,
    updatedAt = null,
    protocol = "",
    username = "",
    password = "",
    url = "",
    connectionStatus = CameraStatus.IN_CONFIGURATION,
    testConnectionImageKey = "",
    modelName,
    datasetName,
    groupId = "",
    cameraGroup = ""
  ) {
    /** @type {string} */
    this.id = id;

    /** @type {string} */
    this.name = name;

    /** @type {string} */
    this.organization = organization;

    /** @type {boolean} */
    this.connected =
      connectionStatus === CameraStatus.CONNECTED || connectionStatus === CameraStatus.CONNECTED_IN_GROUP;

    /** @type {number} */
    this.size = +size;

    /** @type {string} */
    this.type = type;

    /** @type {string} */
    this.userId = userId;

    /** @type {string} */
    this.modelId = modelId;

    /** @type {string} */
    this.datasetId = datasetId;

    /** @type {string} */
    this.lastConsumingExecutionId = lastConsumingExecutionId;

    /** @type {Date} */
    this.createdAt = new Date(createdAt);

    /** @type {string} */
    this.updatedAt = moment(updatedAt).format("DD-MM-YYYY,  HH:mmA");

    /** @type {object} */
    this.config = config;

    /** @type {number} */
    this.fps = fps;

    /** @type {string} */
    this.resolution = resolution;

    /** @type {string} */
    this.username = username;

    /** @type {string} */
    this.password = password;

    /** @type {string} */
    this.protocol = protocol;

    /** @type {string} */
    this.url = url;

    /** @type {string} */
    this.connectionStatus = connectionStatus;

    /** @type {string} */
    this.testConnectionImageKey = testConnectionImageKey;

    /** @type {string} */
    this.modelName = modelName;

    /** @type {string} */
    this.datasetName = datasetName;

    /** @type {string} */
    this.groupId = groupId;

    /** @type {string} */
    this.cameraGroup = cameraGroup;
  }

  static fromApi = CameraMapper;
}

function CameraMapper({
  _id,
  name,
  connected,
  organization,
  size,
  task_type,
  user_id,
  model_id,
  dataset_id,
  last_consuming_execution_id,
  config = {},
  fps = 0,
  resolution,
  created_at = null,
  updated_at = null,
  protocol,
  username,
  password,
  url,
  connection_status,
  test_connection_image_key,
  model_name,
  detection_size,
  dataset_name,
  classification_size,
  group_id,
  camera_group,
}) {
  return new Camera(
    _id,
    name,
    connected,
    organization,
    size,
    task_type,
    user_id,
    model_id,
    dataset_id,
    last_consuming_execution_id,
    config,
    fps,
    resolution,
    created_at,
    updated_at,
    protocol,
    username,
    password,
    url,
    connection_status,
    test_connection_image_key,
    model_name,
    dataset_name,
    group_id,
    camera_group
  );
}
